import React from 'react';
import { Link } from "react-router-dom";
import green_switch from '../assets/images/green_switch.png'
import instructor from '../assets/images/instructor.png';
import purpledot from '../assets/images/purple_squre_dots.b6e7dbcc.svg';
import yellowdot from '../assets/images/yellow_squre_dots.a8deef14.svg';
import Img2 from '../assets/images/real-time.png'
import Img1 from '../assets/images/img.png'
import vdo1 from '../assets/video/vdo1.mp4'
import v1 from '../assets/images/v1.png'
import v2 from '../assets/images/v2.png'
import v3 from '../assets/images/v3.png'
import v4 from '../assets/images/v4.png'

function CpaStudyMaterials() {
  return (
    <>
      <div className="overflow-hidden bg-placement-hero bg-cover w-full">
        <div className="max-w-7xl m-auto relative isolate px-6 pt-14 lg:px-8 h-[55%] md:h-[50%] lg:h-[80%] lg:mb-0 lg:pt-2 xl:pt-2">
          <img src={green_switch} alt="" className="absolute object-contain inset-0 z-10 scale-75 lg:scale-[70%] -mt-14 ml-16 md:ml-32 md:-mt-32 lg:ml-52 lg:-mt-40 xl:-mt-[16rem] mt-[-2px] xl:scale-[65%] xl:ml-96 2xl:ml-[22rem]" />
          <div className="mx-auto py-10 md:py-24 lg:py-48 relative z-10 text-white">
            <div className="mx-auto lg:max-w-5xl">
              <h1 className="text-left lg:text-5xl md:text-4xl text-3xl font-bold text-gray-700 lg:w-[38%] w-[90%] mb-2 lg:leading-[56px]"><span className="block">CPA</span><span className="block">Study Materials</span></h1>

              <div className="scale-[60%] md:scale-75 lg:scale-100 mt-5 md:mt-4 lg:mt-10 flex flex-row gap-10 -ml-24 md:-ml-28 lg:ml-0 items-start justify-start gap-x-2 lg:gap-x-6">
                  <div className="box box_btn transform transition-transform duration-300 hover:scale-110" tabindex="0">
                      <Link to="https://www.kcglobed.com/contactus#EnquireForm"
                          className="relative lg:top-[33px] bg-[#fbb03b] transition duration-300 rounded-3xl bg-primary px-6 py-4 text-sm font-semibold text-gray-700 shadow-sm hover:bg-primary hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary pb-4 cursor-pointer"
                      >
                          Enquiry Now
                      </Link>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative bg-[#f2f2f2] p-4 md:p-8 lg:p-10 py-[51px] pb-24">
        <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
        <div className="flex flex-col items-center">
          <div tabindex="0">
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 items-center xs:max-w-xl lg:max-w-6xl group h-full">
              <div className="flex flex-col ml-0 lg:ml-6">
                <div className="relative overflow-hidden">
                  <div className="max-w-[100rem] mx-auto py-5">
                    <div className="max-w-3xl mx-auto">
                      <h2 className="text-3xl font-semibold text-gray-800 sm:text-4xl md:text-4xl "><span className="uppercase text-xl">CPA Exam Study Guide </span></h2>

                      <h2 className="block flex flex-col text-3xl font-semibold text-gray-800 sm:text-4xl md:text-3xl mt-3 text-primary_text">All that you need to pass four sections of the US CPA Exam <span className='lg:block'>in one go.</span> </h2>
                    </div>
                  </div>
                </div>
              </div>
              <img src={instructor} alt="" className="mt-6 lg:pl-10" />
            </div>
          </div>
        </div>
        <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
      </div>

      <div class="relative lg:py-10 lg:px-20 py-0">
        <div className="lg:max-w-5xl mx-auto flex flex-col gap-2 md:gap-2 lg:gap-2 xl:gap-6 2xl:gap-8 lg:pt-4 text-xl p-3 -mt-4 bg-[#7F56D9] rounded-xl text-[#fff]">
          <div className="relative overflow-hidden">
            <div className="flex flex-col gap-1">
              <div className='mx-auto gap-0 items-center xs:max-w-xl lg:max-w-4xl group h-full'>
                <p className="text-white mb-3 text-center font-bold text-2xl">KC GlobEd’s CPA Review Course: Your Path to Success</p>
                <p className='text-white mb-3 text-center'>At KC GlobEd, our <Link target='_blank' className='text-[#E29E35]' to="https://www.kcglobed.com/cpa-review-course"> CPA Review Course </Link> aligns perfectly with the latest <span className="font-bold">AICPA blueprints, offering comprehensive study materials</span> designed to help you pass all four sections of the CPA Exam in one go.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 md:p-8 lg:p-10">
        <div className="flex flex-col items-center">
          <div tabindex="0" className='transform transition-transform duration-300'>
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 lg:mb-10 items-center xs:max-w-xl lg:max-w-6xl group h-full bg-white">
              <div className="relative h-50 w-30 mb-6 lg:pr-10">
                <video style={{ zIndex: '4' }} className='absolute w-[97%] sm:w-[51.5%] sm:top-[23px] top-[20px] left-[7px] lg:w-[327px] lg:top-[25px] lg:left-[39px]'
                  controls
                  autoPlay
                  muted
                  playsInline
                  loop
                >
                  <source src={vdo1} type="video/mp4" />
                </video>
                <img style={{ zIndex: '3' }} className='relative w-[344px] ml-[0px] lg:w-[344px] lg:ml-[31px]' src={v1} alt="img" />

                <img style={{ zIndex: '3' }} className='absolute bottom-[60px] left-[126px] w-[30px] sm:bottom-[77px] sm:left-[161px] lg:bottom-[77px] lg:left-[191px] lg:w-[30px]' src={v2} alt="v2" />

                <img className='absolute w-[71px] bottom-[31px] left-[-10px] lg:w-[71px] lg:bottom-[43px] lg:left-[21px]' src={v3} alt="v3" />

                <img className='absolute top-[-13px] right-[-27px] w-[93px] sm:right-[261px] lg:top-[-28px] lg:right-[123px] lg:w-[93px]' src={v4} alt="v4" />

              </div>
              <div className="flex flex-col lg:mr-6">
                <p className="text-xl font-semibold md:text-2xl mb-4 placeholder gap-1"><span>Personalized  </span><span className="text-gray-500">Learning for Efficient Study with <span className='lg:block'>T.E.E.E Technology</span> </span></p>

                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  We employ an innovative methodology to minimize study time by customizing the CPA Exam study materials for each student. Our approach ensures you study less while achieving faster results compared to traditional methods.</p>
              </div>
            </div>
          </div>
          <div tabindex="0" className='transform transition-transform duration-300 hover:scale-110'>
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-10 items-center xs:max-w-xl lg:max-w-5xl group h-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
              <div className="flex flex-col ml-0 lg:ml-6">
                <p className="text-xl font-semibold md:text-2xl mb-4"><span>Real-Time </span><span className="text-gray-500 lg:block"> Score Analysis</span></p>
                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  Our CPA Exam study guide includes tools to help you understand your real-time score before you begin studying. This allows you to identify your strengths and weaknesses across different exam sections, enabling you to strategize your study plan efficiently and effectively. </p>
              </div>
              <img src={Img2} alt="" className="mt-6 lg:pl-10" />
            </div>
          </div>


          <div tabindex="0" className='transform transition-transform duration-300 hover:scale-110'>
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-10 items-center xs:max-w-xl lg:max-w-5xl group h-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
              <img src={Img1} alt="" className="h-50 w-30 mb-6 lg:pr-10" />
              <div className="flex flex-col lg:mr-6">
                <p className="text-xl font-semibold md:text-2xl mb-4 placeholder gap-1"><span>KC GlobEd’s  </span><span className="text-gray-500">CPA Review Course:  <br />Your Path to Success </span></p>

                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  At KC GlobEd, our CPA Review Course aligns perfectly with the latest AICPA blueprints, offering comprehensive study materials designed to help you pass all four sections of the CPA Exam in one go.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-8 lg:p-10 bg-[#f5f9f3] pt-10 lg:pt-0">
        <div className="flex flex-col items-center">
          <div tabindex="0" className='transform transition-transform duration-300 hover:scale-110 '>
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-10 items-center xs:max-w-xl lg:max-w-5xl group h-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
              <div className="flex flex-col ml-0 lg:ml-6">
                <p className="text-xl font-semibold md:text-2xl mb-4"><span>Embrace Smart </span><span className="text-gray-500 lg:block">Study Techniques</span></p>
                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  In today's technology-driven world, smart students seek smart solutions. Partner with us for your CPA study needs and take the first step towards passing the <Link target='_blank' className='text-[#E29E35]' to="https://www.kcglobed.com/us-cpa-exam-requirements"> US CPA Exams </Link> on your first attempt. </p>
              </div>
              <img src={Img2} alt="" className="mt-6 lg:pl-10" />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-first-step py-10 bg-center bg-no-repeat bg-cover">
        <div className="flex flex-col items-center">
          <div className="relative overflow-hidden">
            <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
              <div className="max-w-3xl text-center mx-auto">
                <h2 className='font-bold text-white text-3xl'>Grab the Best CPA Review Materials Now!</h2>
                <p className="mt-4 text-md text-medium font-bold text-white">
                  Don’t wait any longer—grab the right CPA Exam materials now and embark on your journey to success. Discover how our <Link target='_blank' className='text-[#E29E35]' to="https://www.kcglobed.com/cpa-review-course"> CPA Review Materials </Link> can help you study more effectively and positively than ever before.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default CpaStudyMaterials;
